module.exports = __webpack_public_path__ + "media/images/pic/banners/sing-up-bd696b15e097f638139beaa06db2049d.svg";